import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import productApiController from "../../services/product.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";
import {
  applyStockQuantityToList,
  applyStockQuantityToProduct,
  normalizeProduct,
  normalizeProductDetailResponse,
  normalizeProductListResponse,
  normalizeStockAdjustmentReasons,
  normalizeStockMovements,
} from "../../services/productContract";

const applyAuthoritativeStockQuantity = (state, productId, stockQuantity) => {
  if (productId == null || stockQuantity == null) return;
  state.isListView = applyStockQuantityToList(state.isListView, productId, stockQuantity);
  state.isDetailData = applyStockQuantityToProduct(state.isDetailData, productId, stockQuantity);
  state.isStockAdjustProduct = applyStockQuantityToProduct(state.isStockAdjustProduct, productId, stockQuantity);
};

// Redux Toolkit stamps every rejectWithValue action with this transport
// placeholder, which is not a user-facing message. It must never reach the
// Products tab alert.
const transportPlaceholder = "Rejected";

const listErrorMessage = (action, fallback) => {
  const message = contentErrorMessage(action, fallback);
  const readable = typeof message === "string" ? message.trim() : "";
  if (!readable || readable === transportPlaceholder) return fallback;
  return readable;
};

export const productStoreApi = createAsyncThunk("product/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const productUpdateApi = createAsyncThunk("product/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const productListViewApi = createAsyncThunk("product/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const productDetailApi = createAsyncThunk("product/detail", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "detail"))
      .catch((error) => HandleError(thunkAPI, error, "detail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const productDeleteApi = createAsyncThunk("product/delete", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .deleted(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "delete"))
      .catch((error) => HandleError(thunkAPI, error, "delete"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const productSuggetionListApi = createAsyncThunk("product/suggetionlist", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .suggetionlist(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "suggetionlist"))
      .catch((error) => HandleError(thunkAPI, error, "suggetionlist"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ProductOptionsDropdown = createAsyncThunk("product/ProductOptionsDropdown", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "ProductOptionsDropdown"))
      .catch((error) => HandleError(thunkAPI, error, "ProductOptionsDropdown"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ProductImportApi = createAsyncThunk("product/Productimport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .productimport(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Productimport"))
      .catch((error) => HandleError(thunkAPI, error, "Productimport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ProductExportApi = createAsyncThunk("product/Productexport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .productexport(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Productexport"))
      .catch((error) => HandleError(thunkAPI, error, "Productexport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ProductStockAdjustApi = createAsyncThunk("product/ProductStockAdjust", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .stockAdjust(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "ProductStockAdjust"))
      .catch((error) => HandleError(thunkAPI, error, "ProductStockAdjust"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ProductStockReasonsApi = createAsyncThunk("product/ProductStockReasons", async (_values, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .stockReasons(undefined, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "ProductStockReasons"))
      .catch((error) => HandleError(thunkAPI, error, "ProductStockReasons"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ProductStockMovementsApi = createAsyncThunk("product/ProductStockMovements", async (formValues, thunkAPI) => {
  try {
    const resposedata = await productApiController
      .stockMovements(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "ProductStockMovements"))
      .catch((error) => HandleError(thunkAPI, error, "ProductStockMovements"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  isOpenedAddForm: "",
  isOpenedEditForm: "",
  isOpenedDetailModal: "",
  isOpenedStockAdjustModal: "",
  isStockAdjustProduct: "",
  isStockReasons: [],
  isStockMovements: [],
  isListView: [],
  isListViewError: "",
  isSuggetionListView: [],
  isSuggetionListError: "",
  isDetailData: "",
  isTabView: "product",
  isSort: "",
  isSearchList: "",
  isSearchName: "",
  isProductManageStock: 0,
  isProductOptionDropdown: [],
  isApiStatus: {
    productStoreApi: "",
    productUpdateApi: "",
    productListViewApi: "",
    productSuggetionListApi: "",
    productDetailApi: "",
    productDeleteApi: "",
    ProductOptionsDropdown: "",
    ProductImportApi: "",
    ProductExportApi: "",
    ProductStockAdjustApi: "",
    ProductStockReasonsApi: "",
    ProductStockMovementsApi: "",
  },
};

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    reset: () => initialState,
    productTabView: (state, action) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "";
      state.isOpenedDetailModal = "";
      state.isTabView = action.payload;
    },
    openAddProductForm: (state = initialState) => {
      state.isOpenedAddForm = "open";
      state.isOpenedEditForm = "";
      state.isOpenedDetailModal = "";
    },
    closeAddProductForm: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "";
      state.isOpenedDetailModal = "";
    },
    openEditProductForm: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "open";
      state.isOpenedDetailModal = "";
    },
    closeEditProductForm: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "";
      state.isOpenedDetailModal = "";
    },
    openProductDetailModal: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "";
      state.isOpenedDetailModal = "open";
    },
    closeProductDetailModal: (state = initialState) => {
      state.isOpenedAddForm = "";
      state.isOpenedEditForm = "";
      state.isOpenedDetailModal = "";
    },
    productSort: (state, action) => {
      // let sort = state.isSort ? state.isSort : {};
      // state.isSort = Object.assign(sort, action.payload);
      state.isSort = action.payload;
    },
    productSortRemove: (state) => {
      state.isSort = "";
    },
    openProductSearchList: (state) => {
      state.isSearchList = "open";
    },
    closeProductSearchList: (state) => {
      state.isSearchList = "";
    },
    productSearchName: (state, action) => {
      state.isSearchName = action.payload;
    },
    productManageStock: (state, action) => {
      state.isProductManageStock = action.payload;
    },
    openStockAdjustModal: (state, action) => {
      state.isOpenedStockAdjustModal = "open";
      state.isStockAdjustProduct = action.payload;
    },
    closeStockAdjustModal: (state) => {
      state.isOpenedStockAdjustModal = "";
      state.isStockAdjustProduct = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(productStoreApi.pending, (state) => {
        state.isApiStatus.productStoreApi = 'loading';
      })
      .addCase(productStoreApi.fulfilled, (state, action) => {
        const product = normalizeProduct(action.payload);
        if (state.isListView && state.isListView.data) {
          state.isListView.data = [product, ...state.isListView.data];
        } else {
          state.isListView = { data: [product] };
        }
        state.isApiStatus.productStoreApi = 'succeeded';
      })
      .addCase(productStoreApi.rejected, (state) => {
        state.isApiStatus.productStoreApi = 'failed';
      })
      .addCase(productUpdateApi.pending, (state) => {
        state.isApiStatus.productUpdateApi = 'loading';
      })
      .addCase(productUpdateApi.fulfilled, (state, action) => {
        const { id, ...changes } = normalizeProduct(action.payload);
        const existingData = state.isListView && state.isListView.data && state.isListView.data.find((event) => event.id === id);
        if (existingData) {
          Object.keys(changes).map((keyName) => {
            existingData[keyName] = changes[keyName];
          });
        }
        state.isApiStatus.productUpdateApi = 'succeeded';
      })
      .addCase(productUpdateApi.rejected, (state) => {
        state.isApiStatus.productUpdateApi = 'failed';
      })
      .addCase(productListViewApi.pending, (state) => {
        state.isApiStatus.productListViewApi = 'loading';
        state.isListViewError = "";
      })
      .addCase(productListViewApi.fulfilled, (state, action) => {
        const payload = normalizeProductListResponse(action.payload);
        let old_current_page = state.isListView.current_page ? state.isListView.current_page : "";
        let new_current_page = payload.current_page ? payload.current_page : "";
        let viewdata = state.isListView && state.isListView.data;
        let newviewdata = payload && payload.data;
        state.isListView = payload;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.isListView.data = [...viewdata, ...newviewdata]) : payload;
        }
        state.isApiStatus.productListViewApi = 'succeeded';
        state.isListViewError = "";
      })
      .addCase(productListViewApi.rejected, (state, action) => {
        state.isApiStatus.productListViewApi = 'failed';
        state.isListViewError = listErrorMessage(action, "Unable to load products. Please try again.");
      })
      .addCase(productSuggetionListApi.pending, (state) => {
        state.isApiStatus.productSuggetionListApi = 'loading';
        state.isSuggetionListError = "";
      })
      .addCase(productSuggetionListApi.fulfilled, (state, action) => {
        const payload = normalizeProductListResponse(action.payload);
        let old_current_page = state.isSuggetionListView.current_page ? state.isSuggetionListView.current_page : "";
        let new_current_page = payload.current_page ? payload.current_page : "";
        let viewdata = state.isSuggetionListView && state.isSuggetionListView.data;
        let newviewdata = payload && payload.data;
        state.isSuggetionListView = payload;
        if (old_current_page && new_current_page && old_current_page < new_current_page && old_current_page != new_current_page) {
          viewdata && newviewdata ? (state.isSuggetionListView.data = [...viewdata, ...newviewdata]) : payload;
        }
        state.isApiStatus.productSuggetionListApi = 'succeeded';
        state.isSuggetionListError = "";
      })
      .addCase(productSuggetionListApi.rejected, (state, action) => {
        state.isApiStatus.productSuggetionListApi = 'failed';
        state.isSuggetionListError = listErrorMessage(action, "Unable to search products. Please try again.");
      })
      .addCase(productDetailApi.pending, (state) => {
        state.isApiStatus.productDetailApi = 'loading';
      })
      .addCase(productDetailApi.fulfilled, (state, action) => {
        const detail = normalizeProductDetailResponse(action.payload);
        state.isDetailData = detail;
        applyAuthoritativeStockQuantity(state, detail.id, detail.stock_quantity);
        state.isApiStatus.productDetailApi = 'succeeded';
      })
      .addCase(productDetailApi.rejected, (state) => {
        state.isDetailData = "";
        state.isApiStatus.productDetailApi = 'failed';
      })
      .addCase(productDeleteApi.pending, (state) => {
        state.isApiStatus.productDeleteApi = 'loading';
      })
      .addCase(productDeleteApi.fulfilled, (state, action) => {
        const { id } = normalizeProduct(action.payload);
        state.isListView.data = state.isListView.data ? state.isListView.data.filter((item) => item.id != id) : state.isListView.filter((item) => item.id != id);
        state.isApiStatus.productDeleteApi = 'succeeded';
      })
      .addCase(productDeleteApi.rejected, (state) => {
        state.isApiStatus.productDeleteApi = 'failed';
      })
      .addCase(ProductOptionsDropdown.pending, (state) => {
        state.isApiStatus.ProductOptionsDropdown = 'loading';
      })
      .addCase(ProductOptionsDropdown.fulfilled, (state, action) => {
        state.isProductOptionDropdown = action.payload;
        state.isApiStatus.ProductOptionsDropdown = 'succeeded';
      })
      .addCase(ProductOptionsDropdown.rejected, (state) => {
        state.isProductOptionDropdown = [];
        state.isApiStatus.ProductOptionsDropdown = 'failed';
      })
      .addCase(ProductImportApi.pending, (state) => {
        state.isApiStatus.ProductImportApi = 'loading';
      })
      .addCase(ProductImportApi.fulfilled, (state) => {
        state.isApiStatus.ProductImportApi = 'succeeded';
      })
      .addCase(ProductImportApi.rejected, (state) => {
        state.isApiStatus.ProductImportApi = 'failed';
      })
      .addCase(ProductExportApi.pending, (state) => {
        state.isApiStatus.ProductExportApi = 'loading';
      })
      .addCase(ProductExportApi.fulfilled, (state) => {
        state.isApiStatus.ProductExportApi = 'succeeded';
      })
      .addCase(ProductExportApi.rejected, (state) => {
        state.isApiStatus.ProductExportApi = 'failed';
      })
      .addCase(ProductStockReasonsApi.pending, (state) => {
        state.isApiStatus.ProductStockReasonsApi = 'loading';
      })
      .addCase(ProductStockReasonsApi.fulfilled, (state, action) => {
        state.isStockReasons = normalizeStockAdjustmentReasons(action.payload);
        state.isApiStatus.ProductStockReasonsApi = 'succeeded';
      })
      .addCase(ProductStockReasonsApi.rejected, (state) => {
        state.isStockReasons = [];
        state.isApiStatus.ProductStockReasonsApi = 'failed';
      })
      .addCase(ProductStockAdjustApi.pending, (state) => {
        state.isApiStatus.ProductStockAdjustApi = 'loading';
      })
      .addCase(ProductStockAdjustApi.fulfilled, (state, action) => {
        const payload = action.payload && typeof action.payload === "object" ? action.payload : {};
        const productId = payload.product_id != null ? payload.product_id : (state.isStockAdjustProduct && state.isStockAdjustProduct.id);
        applyAuthoritativeStockQuantity(state, productId, payload.stock_quantity);
        state.isApiStatus.ProductStockAdjustApi = 'succeeded';
      })
      .addCase(ProductStockAdjustApi.rejected, (state) => {
        state.isApiStatus.ProductStockAdjustApi = 'failed';
      })
      .addCase(ProductStockMovementsApi.pending, (state) => {
        state.isApiStatus.ProductStockMovementsApi = 'loading';
      })
      .addCase(ProductStockMovementsApi.fulfilled, (state, action) => {
        state.isStockMovements = normalizeStockMovements(action.payload);
        state.isApiStatus.ProductStockMovementsApi = 'succeeded';
      })
      .addCase(ProductStockMovementsApi.rejected, (state) => {
        state.isStockMovements = [];
        state.isApiStatus.ProductStockMovementsApi = 'failed';
      })
  },
});
// Action creators are generated for each case reducer function
export const { reset, productTabView, openAddProductForm, closeAddProductForm, openEditProductForm, closeEditProductForm, productTabGridView, openProductDetailModal, closeProductDetailModal, productDetailTab, productSort, productSortRemove, openProductSearchList, closeProductSearchList, productSearchName, productManageStock, openStockAdjustModal, closeStockAdjustModal } = productSlice.actions;
export default productSlice.reducer;
